export function setSessionData({response, message, auth, history}) {
    const { expires_in, token } = response.data;
    message.success('Sesión iniciada correctamente', 5);
    const expirationDate = new Date(expires_in * 1000);
    auth.saveUserSession('tokenExpiration', token, expirationDate);
    history.push('/portal');
}